import Icon from '__core/modules/atoms/Icons';
import DialogDefault from '__core/modules/components/dialogs/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, withTranslation } from 'react-i18next';

const DialogConfirm = ({ buttonTextCancel, buttonTextSucess, detailedList, name, onClose = function () {}, onSuccess, open = false, t, text, title, ...rest }) => {
  // Apply default values inside component to avoid "Cannot access before initialization" error
  const finalButtonTextCancel = buttonTextCancel || (t ? t('actions:Cancel') : 'Cancel');
  const finalButtonTextSucess = buttonTextSucess || (t ? t('actions:Delete') : 'Delete');
  const titleId = React.useId();

  return (
    <DialogDefault
      buttonTextCancel={finalButtonTextCancel}
      buttonTextSucess={finalButtonTextSucess}
      className={'dialog-confirm'}
      onCancel={onClose}
      onClose={onClose}
      onSuccess={onSuccess}
      open={open}
      hideHeader
      aria-labelledby={titleId}
      {...rest}
    >
      <div className="d-flex align-items-center">
        <Icon type="icon-warning-circle" fontSize="large" color="error" />
        <span className="dialog-confirm__title ml-3" id={titleId}>
          {title || t('actions:Delete')}
        </span>
      </div>

      <div className="mt-4">
        <p className="dialog-confirm__text">{text || <Trans i18nKey="common:Delete x?" values={{ name }} components={{ strong: <strong /> }} />}</p>
        <p className="dialog-confirm__text">
          {detailedList?.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </p>
      </div>
    </DialogDefault>
  );
};

DialogConfirm.propTypes = {
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  detailedList: PropTypes.array,
  name: PropTypes.string,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func,
  text: PropTypes.node,
  title: PropTypes.node,
};

export default withTranslation(['course', 'actions', 'common'])(DialogConfirm);
